<template>
<link v-if="isUmbraco" rel="stylesheet" href="/assets/index.css" />

  <div :class="navigationStyle">
    <a
      href="/"
      class="lg:order-2 h-6 lg:h-[26px] lg:w-[60px] lg:rotate-90 lg:origin-top lg:-translate-y-8 cursor-pointer"
      aria-label="Home"
    >
      <logo-component color="white" :subsite="subsite" />
    </a>
    <button
      @click="toggle"
      class="w-8 h-[21px] cursor-pointer relative lg:order-1"
      aria-label="Toggle Navigation"
      :aria-expanded="isOpen"
    >
      <div
        :class="[
          'bg-white h-[3px] absolute left-0 w-full transition-all duration-300 ease-out-cubic',
          isOpen ? 'top-[50%] rotate-45' : 'top-0 rotate-0',
        ]"
      ></div>
      <div
        :class="[
          'bg-white h-[3px] absolute left-0 top-[9px] w-full transition-opacity',
          isOpen ? 'opacity-0' : 'opacity-100',
        ]"
      ></div>
      <div
        :class="[
          'bg-white h-[3px] absolute left-0 w-full transition-all duration-300 ease-out-cubic',
          isOpen ? 'top-[50%] -rotate-45' : 'rotate-0 top-[18px]',
        ]"
      ></div>
    </button>
  </div>
  <navigation-dropdown
    :isOpen="isOpen"
    :navlinks="navlinks"
    :subNavLinks="subNavLinks"
    :searchFieldLabel="searchFieldLabel"
    :searchPageUrl="searchPageUrl"
    :subsite="subsite"
    @toggle="toggle"
  />
</template>

<script setup lang="ts">
import {
  IDropdownLink,
  INavigationProps,
  INavLink,
} from "@/types/components/INavigationProps";
import LogoComponent from "@atoms/Logo/Logo.ce.vue";
import NavigationDropdown from "@organisms/Navigation/NavigationDropdown.vue";
import { computed, ref, toRefs } from "vue";
import { NavLinkType } from "@/util/constants";

const props = withDefaults(defineProps<INavigationProps>(), {});
const {
  globalNavLinks,
  globalServiceNavLinks,
  searchFieldLabel,
  searchPageUrl,
  subsite,
} = toRefs(props);
//console.log("initial site", subsite.value);
const isOpen = ref(false);

const navlinks = computed(() => {
  if (!globalNavLinks?.value) return [];
  const linksArray = globalNavLinks.value.map((link) => {
    if (!link) return;
    if (link.linkType === NavLinkType.DROPDOWN) {
      const { linkType, links, name } = link as IDropdownLink;
      return {
        linkType: linkType,
        name: name,
        links,
      };
    } else if (link.linkType === NavLinkType.LINK) {
      const { linkType, name, url } = link as INavLink;
      return {
        linkType: linkType,
        name: name,
        url: url,
      };
    }
  });
  return linksArray;
});

const subNavLinks = computed((): INavLink[] => {
  if (!globalServiceNavLinks?.value) return [];
  return globalServiceNavLinks?.value;
});

const navigationStyle = computed(() => {
  let bgColor = subsite?.value == "cowiFonden" ? "bg-cowifond-green" : "bg-orange";
  return `fixed z-50 w-screen h-[60px] top-0 start-0 ${bgColor} flex px-6 md:px-10 py-[18px] justify-between lg:w-[60px] lg:h-screen lg:bottom-0 lg:left-auto lg:right-0 lg:top-0 lg:flex-col lg:px-[14px] lg:py-4`;
});

function toggle() {
  isOpen.value = !isOpen.value;
}
</script>
